import { Container, Header, PieChart, SpaceBetween } from '@amzn/awsui-components-core';
import React from 'react';
import { EmptyStateMessage } from '../EmptyStateMessage';
import { PieChartDataSeries } from './TicketsInterfaces';
import { FinTechOpsMessages } from '../FinTechOpsConstants';
import { i18nStringPieChart } from '../i18nStrings';
import { ChartSummaryButton } from '../../generic-components/ai-summary-components/ChartSummaryButton';

type dataPieProps = {
  data: PieChartDataSeries[];
  showSummaryButton?: boolean;
};
export const TicketStatusPieGraph = ({ data, showSummaryButton }: dataPieProps) => {
  return (
    <Container
      fitHeight={true}
      header={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <Header variant="h2">Tickets by Status</Header>
          {showSummaryButton && (
            <div style={{ flexShrink: 0 }}>
              <ChartSummaryButton pageType={'Tickets'} chartTitle="Tickets by Status" chartData={data as any[]} chartType={'Pie'} />
            </div>
          )}
        </div>
      }
    >
      <PieChart
        data={data}
        segmentDescription={(datum: { value: number }, sum: number) => ` ${((datum.value / sum) * 100).toFixed(0)}%`}
        i18nStrings={i18nStringPieChart()}
        ariaDescription="Pie chart showing how many resources are currently in which state."
        ariaLabel="Pie chart"
        size="medium"
        errorText="Error loading data."
        loadingText="Loading Chart"
        hideFilter
        recoveryText="Retry"
        empty={<EmptyStateMessage title={FinTechOpsMessages.emptyStateMessage} subtitle={FinTechOpsMessages.emptyStateMessageDescription} />}
        noMatch={FinTechOpsMessages.noMatchMessage}
      />
    </Container>
  );
};
